export const sortItems = ({ isSortAsc, items }) => {
  return [...items].sort((a, b) =>
    isSortAsc
      ? a.attributes.name.localeCompare(b.attributes.name)
      : b.attributes.name.localeCompare(a.attributes.name)
  );
};
